/* Mobile star-rating gallery overlay
   ----------------------------------
   On phone/tablet viewports the `.dd-block--star-rating` section block is
   moved INTO `.dd-gallery-card` as an absolutely-positioned chip in the
   gallery's bottom-left corner — the same corner the existing
   `_sampleZoomContrast` luminance sampler already reads, so the chip's
   text/border colors flip via `.dd-gallery-card.--on-light` for free.

   On desktop (>=1024px) the block stays in its original flex-stack slot.
   We track the original parent + nextSibling so the move is fully
   reversible across viewport resizes (devtools, orientation change). */
(function () {
  if (window.__ddPdpRatingOverlayInit) return;
  window.__ddPdpRatingOverlayInit = true;

  var MOBILE_MQ = '(max-width: 1023px)';

  function init() {
    var card = document.querySelector('.dd-gallery-card');
    var block = document.querySelector('.dd-block--star-rating');
    if (!card || !block) return;

    var origParent = block.parentNode;
    var origNext = block.nextSibling;

    function moveIn() {
      if (block.parentNode === card) return;
      block.classList.add('dd-gallery-card__rating');
      card.appendChild(block);
    }

    function moveOut() {
      if (block.parentNode !== card) return;
      block.classList.remove('dd-gallery-card__rating');
      if (origParent && origParent.isConnected) {
        origParent.insertBefore(block, origNext);
      }
    }

    var mq = window.matchMedia(MOBILE_MQ);

    function apply() {
      if (mq.matches) moveIn();
      else moveOut();
    }

    apply();

    if (typeof mq.addEventListener === 'function') {
      mq.addEventListener('change', apply);
    } else if (typeof mq.addListener === 'function') {
      // Safari < 14 fallback.
      mq.addListener(apply);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
